import { Ref, ref } from "vue";

export type AlertType =
  | "alert-primary"
  | "alert-secondary"
  | "alert-success"
  | "alert-danger"
  | "alert-warning"
  | "alert-info"
  | "alert-info-dark"
  | "alert-light"
  | "alert-dark";

type ComposableResult = {
  alertType: Ref<AlertType>;
  alertMessage: Ref<string>;
  alertIcon: Ref<string>;
  showAlert: Ref<boolean>;
  alertClosable: Ref<boolean>;
  dismissAlert: () => void;
};

export function useAlert(): ComposableResult {
  const alertType = ref<AlertType>("alert-warning");
  const alertMessage = ref("");
  const alertIcon = ref("fa fa-exclamation-triangle");
  const showAlert = ref(false);
  const alertClosable = ref(true);

  const dismissAlert = () => {
    showAlert.value = false;
  };

  return {
    alertType,
    alertMessage,
    alertIcon,
    showAlert,
    alertClosable,
    dismissAlert,
  };
}
